module.exports = __webpack_public_path__ + "img/meetsanta1.89fec2fe.jpg";